import { render, staticRenderFns } from "./TopUserPlatform.vue?vue&type=template&id=47a223c6&scoped=true&"
import script from "./TopUserPlatform.vue?vue&type=script&lang=js&"
export * from "./TopUserPlatform.vue?vue&type=script&lang=js&"
import style0 from "./TopUserPlatform.vue?vue&type=style&index=0&id=47a223c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a223c6",
  null
  
)

export default component.exports